module.exports = __webpack_public_path__ + "img/u23.68808d6c.png";